<template>
  <div>
    <baseEdit />
  </div>
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'equipmentMortgageEdit',
    components: {
      baseEdit,
    },
  };
</script>
